module.exports = __webpack_public_path__ + "img/logo.0f48174c.png";